/* Floating WhatsApp returns button.
   The <details> element handles open/close on click by itself; this only adds
   the expected niceties: close when clicking outside, and close on Escape. */
(function () {
  function init() {
    var fab = document.querySelector('.wa-fab');
    if (!fab) return;

    document.addEventListener('click', function (event) {
      if (fab.open && !fab.contains(event.target)) {
        fab.open = false;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && fab.open) {
        fab.open = false;
        var toggle = fab.querySelector('.wa-fab__toggle');
        if (toggle) toggle.focus();
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
